/** Gewohnheiten eines Bereichs (F-01): heute abhaken, Serie und 30-Tage-Quote. */
import { Link } from 'react-router-dom';

import { useHabitsWithStats } from '@/modules/habits/useHabits';
import { toggleHabitDone } from '@/db/repositories/habits';
import { today } from '@/lib/datetime';
import { cn } from '@/lib/utils/cn';
import type { ID } from '@/domain/types';

export function BereichGewohnheiten({ areaId }: { areaId: ID }) {
  const heute = today();
  const liste = useHabitsWithStats(false, areaId);

  return (
    <section aria-label="Gewohnheiten" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-4 py-3.5">
      <h2 className="flex items-baseline gap-2 text-sm font-semibold">
        Gewohnheiten
        <Link to="/gewohnheiten" className="ml-auto text-[11px] font-normal text-ink-faint hover:text-ink hover:underline">Alle</Link>
      </h2>
      {liste.length === 0 && <p className="text-sm text-ink-faint">Keine Gewohnheiten in diesem Bereich.</p>}
      <ul className="flex flex-col gap-1">
        {liste.map(({ habit, done, streak, rate }) => {
          const erledigt = done.has(heute);
          return (
            <li key={habit.id} className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={erledigt} onChange={() => void toggleHabitDone(habit.id, heute)}
                aria-label={`${habit.name} heute erledigt`} className="size-4 shrink-0 accent-[var(--color-accent)]" />
              <span className={cn('min-w-0 flex-1 truncate', erledigt && 'text-ink-faint line-through')}>{habit.name}</span>
              <span className="shrink-0 text-[11px] tabular-nums text-ink-faint" title="Serie · Quote der letzten 30 Tage">
                {streak.current > 0 ? `${streak.current} in Folge · ` : ''}{rate.percent} %
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
